import { ContextMenu, Paragraph } from '@welbe/web-design-system';
import React, { useContext, useEffect } from 'react';
import { BiFile, BiPrinter } from 'react-icons/bi';
import { Container } from './ProfileFileMenu.styles';
import { useLocation } from 'react-router-dom';
import { JobProfileContext } from 'Views/JobProfile/JobProfile.context';

type OptionsProps = {
	action: 'download' | 'print';
	title: string;
	icon: React.ElementType;
};

type MenuOptionProps = {
	title: string;
	icon: React.ElementType;
	onClick: () => void;
};

type ProfileFileMenuProps = {
	onClick: (action: 'download' | 'print') => void;
};

const options: OptionsProps[] = [
	{
		action: 'download',
		title: 'Descargar PDF',
		icon: BiFile,
	},
	{
		action: 'print',
		title: 'Imprimir',
		icon: BiPrinter,
	},
];

const MenuOption = ({ onClick, title, icon: Icon }: MenuOptionProps) => {
	return (
		<Container onClick={onClick}>
			<Paragraph
				cursor="pointer"
				fontSize="16px"
				fontWeight="600"
				color="#5082C2"
			>
				{title}
			</Paragraph>
			<Icon size="16px" color="#5082C2" />
		</Container>
	);
};

export const ProfileFileMenu = ({ onClick }: ProfileFileMenuProps) => {
	const [preventFirstRender, setPreventFirstRender] = React.useState(true);
	const location = useLocation();
	const { isSummaryLoading, isSummaryMountingLoading, setShouldUpdateSummary } =
		useContext(JobProfileContext);

	const handleClick = async (action: 'download' | 'print') => {
		if (action === 'download') {
			setShouldUpdateSummary(true);
			return;
		}

		onClick(action);
	};

	useEffect(() => {
		if (!preventFirstRender && !isSummaryMountingLoading) {
			onClick('download');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isSummaryMountingLoading]);

	useEffect(() => {
		setPreventFirstRender(false);
	}, []);

	if (!location.pathname.includes('summary')) return null;

	return (
		<ContextMenu
			label="Descargar perfil"
			disabled={isSummaryLoading}
			loading={isSummaryMountingLoading}
			options={options.map(({ action, title, icon }) => (
				<MenuOption
					key={title}
					title={title}
					icon={icon}
					onClick={() => handleClick(action)}
				/>
			))}
		/>
	);
};
